var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbListGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    fill: "#ccc",
    opacity: 0.999,
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 1h-16v-2h16z",
    transform: "translate(7 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 1h-16v-2h16z",
    transform: "translate(7 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 1h-10v-2h10z",
    transform: "translate(7 20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbListGrey);
export default __webpack_public_path__ + "static/media/bb-list_grey.9ffa310fedd9df5e81f9823f0bdf7ee9.svg";
export { ForwardRef as ReactComponent };